import type { SeedanceGenerationState } from "@seedance/contracts";
import { UsageListing } from "./UsagePage.js";
import { generationStateLabels } from "./AdminFilters.js";
export function TaskState({ state }: { state: SeedanceGenerationState }) { return <span>{generationStateLabels[state]}</span>; }
export function GenerationTasksPage() { return <UsageListing mode="tasks" />; }
